import React from 'react'

import Separator from '../../../../components/pdf/Separator'
import SecondPage from '../sections/SecondPage'
import FourthPage from '../sections/FourthPage'
import ThirdPage from '../sections/ThirdPage'
import LastPage from '../sections/LastPage'
import FifthPage from '../sections/FifthPage'
import CoverPage from '../sections/CoverPage'

const Content = () => {
  return (
    <>
      <CoverPage />
      <Separator weight={10} />
      <SecondPage />
      <Separator weight={10} />
      <ThirdPage />
      <Separator weight={10} />
      <FourthPage />
      <Separator weight={10} />
      <FifthPage />
      <LastPage />
    </>
  )
}

export default Content
